import { useMemo } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { getPreview } from "../../resources/preview";

export const usePreviewUrl = (resourceType: ResourceTypeLink, resourceName: string) =>
  useMemo(() => getPreview(resourceType, resourceName), [resourceName]);

export const useProjectPreviewUrl = (projectName: string) => usePreviewUrl(ResourceTypeLink.Project, projectName);

export const useTablePreviewUrl = (tableName: string) => usePreviewUrl(ResourceTypeLink.Table, tableName);
